import { render } from "./ChatDrawer.vue?vue&type=template&id=42f9ad24&scoped=true"
import script from "./ChatDrawer.vue?vue&type=script&lang=js"
export * from "./ChatDrawer.vue?vue&type=script&lang=js"

import "./ChatDrawer.vue?vue&type=style&index=0&id=42f9ad24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f9ad24"]])

export default __exports__